
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vida/ir-workshop-instructional-library",
      function () {
        return require("private-next-pages/vida/ir-workshop-instructional-library/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vida/ir-workshop-instructional-library"])
      });
    }
  